export enum ELocalStorageKeys {
 ChatId = 'chat_id',
 TemporaryToken = 'temporary_token',
 Timezone = 'timezone',
}
